<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><a id="file_028"><img alt="Image" src="images/f0016-01.jpg"/></a></p><a id="file_028">
<p class="caption">The tubby bellies of Grumman FF-1 fighters made them instantly recognizable in the air. Here, a flight of three FF-1s, called “Fifis” by navy aviators, cruise in cloudy skies. The blue and white markings on the cowlings indicate that the aircraft are from different flight sections. <em>U.S. Navy via Stan Piet</em></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// file_028.vue?c179edf8